import HttpService from './baseHttp'

// 获取当前组织下所有用户
export const HttpUserList = (data = {}) => HttpService.get("/api/v1/User/findAllByContextId", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 获取当前组织下配置
export const HttpGetNotifyList = (data = {}) => HttpService.post("/api/v2/orderExceptionNotify/findByFilters", data);
// 存储当前组织下配置
export const HttpSaveNotifyList = (data = {}) => HttpService.post("/api/v2/orderExceptionNotify/saveOne", data);